import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { MainRoutingModule } from './main-routing.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListYourPropertyComponent } from '@app/list-your-property/list-your-property.component';
import { MobileDatePipe } from '@app/when-mobile/mobile-date.pipe';
import { SignupComponent } from '@app/signup/signup.component';
import { DayComponent } from '@app/when/day/day.component';
import { PlaceComponent } from '@app/where/place/place.component';
import {DirectivesModule} from "@app/directives/directives.module";
import {PipesModule} from "@app/pipes/pipes.module";
import { ChannelManagersComponent } from '@app/channel-managers/channel-managers.component';
import {ComponentsModule} from "@app/components/components.module";
import { QRCodeModule } from 'angularx-qrcode';
import { QrCodeCtaComponent } from 'qr-code-cta/qr-code-cta.component';
import { SkeletonCardComponent } from '@app/skeleton-card/skeleton-card.component';
import { CardsMobileComponent } from '@app/cards-mobile/cards-mobile.component';
import { ExploreMobileComponent } from '@app/explore-mobile/explore-mobile.component';
import { ExploreComponent } from '@app/explore/explore.component';
import { MonthPipe } from '@app/when/month.pipe';
import { LogoComponent } from '@app/logo/logo.component';
import { DownloadComponent } from '@app/download/download.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MainRoutingModule,
    NgOptimizedImage,
    AngularSvgIconModule,
    FormsModule,
    ReactiveFormsModule,
    PlaceComponent,
    MobileDatePipe,
    MonthPipe,
    DayComponent,
    // MainComponent,
    SignupComponent,
    ListYourPropertyComponent,
    DirectivesModule,
    PipesModule,
    ListYourPropertyComponent,
    SignupComponent,
    ChannelManagersComponent,
    ComponentsModule,
    QRCodeModule,
    QrCodeCtaComponent,
    DownloadComponent,
    SkeletonCardComponent,
    CardsMobileComponent,
    ExploreMobileComponent,
    ExploreComponent,
    LogoComponent
  ]
})
export class MainModule { }
